import actionTypes from "./actionTypes";
import * as ulohaUtils from "../utils/ulohaUtils";

export const changeUloha = (uloha) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_ULOHA,
      data: uloha,
    });
  };
};

const getListUlohaRequest = () => ({
  type: actionTypes.GET_LIST_ULOHA_REQUEST,
});
const getListUlohaSuccess = (res) => ({
  type: actionTypes.GET_LIST_ULOHA_SUCCESS,
  res,
});
const getListUlohaFailure = (error) => ({
  type: actionTypes.GET_LIST_ULOHA_FAILURE,
  error,
});
export const getListUloha = (filter, sort, page) => {
  return async (dispatch) => {
    try {
      dispatch(getListUlohaRequest());
      let res = await ulohaUtils.getListUloha(filter, sort, page);
      dispatch(getListUlohaSuccess(res));
    } catch (error) {
      dispatch(getListUlohaFailure(error));
    }
  };
};
